"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactInfiniteScrollComponent = _interopRequireDefault(require("react-infinite-scroll-component"));

var _reactQuery = require("react-query");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _request = require("@nicbase/request");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _mediaBox = _interopRequireDefault(require("../box/media-box"));

var _textBox = _interopRequireDefault(require("../box/text-box"));

var _homelet = _interopRequireDefault(require("./homelet"));

require("./home.scss");

var _homeletModule = _interopRequireDefault(require("./homelet.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var PAGE_SIZE = 10;

var HomePresentation = function HomePresentation(_ref) {
  var responsiveMode = _ref.responsiveMode;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useUser = (0, _nicbaseReducers.useUser)(),
      locale = _useUser.locale;

  var helpCenterUrl = locale.substring(0, Math.max(2, locale.lastIndexOf('-'))) === 'de' ? 'https://help.nic-place.com' : 'https://help.nic-place.com/en';
  var createTicketUrl = 'https://fourkites.my.site.com/publicKB/s/nicsupport'; // request to load the table data

  var _useInfiniteQuery = (0, _reactQuery.useInfiniteQuery)(['home.contentBoxes'], /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var _ref2$pageParam, pageParam, _yield$request, body;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$pageParam = _ref2.pageParam, pageParam = _ref2$pageParam === void 0 ? 0 : _ref2$pageParam;
              _context.next = 3;
              return request((0, _nicbaseReducers.findContentBoxesForUser)(pageParam, PAGE_SIZE));

            case 3:
              _yield$request = _context.sent;
              body = _yield$request.body;
              return _context.abrupt("return", body.contentBoxes || []);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), {
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      if ((lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) === PAGE_SIZE) {
        return allPages.length;
      }

      return undefined;
    },
    select: function select(data) {
      return data.pages.flat();
    },
    onSuccess: function onSuccess(boxes) {
      return dispatch({
        type: _nicbaseReducers.FIND_CONTENT_BOXES_FOR_USER_SUCCESS,
        body: {
          contentBoxes: boxes
        }
      });
    }
  }),
      isLoading = _useInfiniteQuery.isLoading,
      _useInfiniteQuery$dat = _useInfiniteQuery.data,
      contentBoxes = _useInfiniteQuery$dat === void 0 ? [] : _useInfiniteQuery$dat,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      hasNextPage = _useInfiniteQuery.hasNextPage;

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "home-container",
    className: "home"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "scrollDiv"
  }, isLoading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-full w-full"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null)) : /*#__PURE__*/_react["default"].createElement("div", {
    id: "home-infinite-scrolling",
    className: "wrapper-left"
  }, /*#__PURE__*/_react["default"].createElement(_reactInfiniteScrollComponent["default"], {
    dataLength: contentBoxes.length,
    next: fetchNextPage,
    scrollableTarget: responsiveMode.mode === 'desktop' || responsiveMode.mode === 'desktop-large' ? 'home-infinite-scrolling' : 'home-container',
    hasMore: hasNextPage,
    loader: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null)
  }, contentBoxes.map(function (contentBox) {
    return /*#__PURE__*/_react["default"].createElement(_homelet["default"], {
      key: contentBox.id,
      className: _homeletModule["default"].white,
      header: contentBox.category,
      contentBackground: true
    }, contentBox.media ? /*#__PURE__*/_react["default"].createElement(_mediaBox["default"], {
      contentBox: contentBox
    }) : /*#__PURE__*/_react["default"].createElement(_textBox["default"], {
      contentBox: contentBox
    }));
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wrapper-right"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: helpCenterUrl,
    className: "block m-5 p-5 bg-primary rounded text-white shadow text-center lg:p-10",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-white my-5  p-4  w-full text-primary text-xl rounded inline-flex justify-center items-center md:block xl:inline-flex"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Magnifier, {
    className: "h-8 w-8 inline-block md:block md:mx-auto xl:inline-block xl:mx-0"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.helpCenter.header"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "m-auto md:w-3/4 my-5 text-base"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.helpCenter.content"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-3"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: createTicketUrl,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "p-2 bg-blue-200 uppercase font-bold hover:bg-blue-100 rounded transition-colors duration-200"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.helpCenter.createTickets"
  })))), /*#__PURE__*/_react["default"].createElement("button", {
    className: "p-2 bg-blue-200 uppercase font-bold hover:bg-blue-100 rounded transition-colors duration-200"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.helpCenter.button"
  }))))));
};

HomePresentation.propTypes = {
  responsiveMode: _propTypes["default"].shape({
    mode: _propTypes["default"].string
  })
};
HomePresentation.defaultProps = {
  responsiveMode: {
    mode: 'desktop'
  }
};
var _default = HomePresentation;
exports["default"] = _default;